import React from 'react';
import { useImmer } from 'use-immer';
import { CenterRowDiv, Span, Text } from 'styles';
import { Icon } from 'components/common/Icon';
import { Spinner } from 'components/loading/Spinner';

import outdoorWeatherStationService from 'services/outdoor/outdoor-weather-station-service';
import commonSensorService from 'services/common-sensor-service';

import * as S from './MonitoringStyle';

export function Monitoring(props) {
  const icon = {
    TEMP_OUTDOOR: 'Temperature',
    RH_OUTDOOR: 'Humidity',
    WIND_OUTDOOR: 'WindDirection',
    WINDSPEED_OUTDOOR: 'WindSpeed',
    SOLAR_OUTDOOR: 'Insolation',
  };

  const background = {
    TEMP_OUTDOOR: 'secondary50',
    RH_OUTDOOR: '#DBFBFD',
    WIND_OUTDOOR: '#EEEEFF',
    WINDSPEED_OUTDOOR: '#FFF7EE',
    SOLAR_OUTDOOR: '#FFEEEE',
  };

  const [loading, setLoading] = React.useState(true);
  const [data, updateData] = useImmer({
    sensors: [
      { label: '온도', type: 'temperature', val: ''},
      { label: '습도', type: 'humidity', val: ''},
      { label: '풍향', type: 'windDirection', val: ''},
      { label: '풍속', type: 'windSpeed', val: ''},
      { label: '일사량', type: 'insolation', val: ''},
    ]
  });

  React.useEffect(() => {
    const fetchData = async () => {
      let weatherStations = [];

      const getValue = (inputList, sensorTypePrefix) => {
        let value = '';

        if (inputList) {
          const filter = inputList.filter((s) => s.sensor_type.startsWith(sensorTypePrefix));

          if (filter && filter.length > 0) {
            value = filter[0].sensor_value;
          }
        }

        return value;
      }

      try {
        weatherStations = await outdoorWeatherStationService.listWeatherStations();
      } catch (e) {
        console.error(e);
      }

      if (weatherStations) {
        const dataSensors = [
          { label: '온도', type: 'TEMP_OUTDOOR', val: getValue(weatherStations, 'TEMP_OUTDOOR')},
          { label: '습도', type: 'RH_OUTDOOR', val: getValue(weatherStations, 'RH_OUTDOOR')},
          { label: '풍향', type: 'WIND_OUTDOOR', val: getValue(weatherStations, 'WIND_OUTDOOR')},
          { label: '풍속', type: 'WINDSPEED_OUTDOOR', val: getValue(weatherStations, 'WINDSPEED_OUTDOOR')},
          { label: '일사량', type: 'SOLAR_OUTDOOR', val: getValue(weatherStations, 'SOLAR_OUTDOOR')},
        ]

        updateData((draft) => {
          draft.sensors = dataSensors
        })
      }

      setLoading(false)
    }

    setLoading(true);
    fetchData();
  }, [])

  return (
    <>
      { loading && (
        <CenterRowDiv $justifyContent="center" $padding="10px">
          <Spinner $width={25} $height={25}/>
        </CenterRowDiv>
      )}
      { !loading && (
        <S.GridList>
          {data.sensors && data.sensors.map((item, index) => (
            <S.MonitorItem
              key={`monitor_${index}`}
              $line={index % 2 !== 1 && index !== data.sensors.length - 1}
              $paddingLeft={index % 2 !== 0 && 16}
            >
              <S.IconDiv $bgColor={background[item.type]}>
                <Icon name={icon[item.type] || 'Insolation'} />
              </S.IconDiv>
              <CenterRowDiv
                $flex={1}
                $padding={index % 2 !== 1 ? '9px 16px 8px 8px' : '9px 0 8px 8px'}
                $justifyContent="space-between"
              >
                <Text $color="supportive">{item.label}</Text>
                <CenterRowDiv $gap={8}>
                  <Text $type="b20">{item.val}</Text>
                  <Span $type="12" $color="assistive">
                    {commonSensorService.getSensorUnit(item.type)}
                  </Span>
                </CenterRowDiv>
              </CenterRowDiv>
            </S.MonitorItem>
          ))}
        </S.GridList>
      )}
    </>
  );
}
